import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { Header } from "@client/shared/components";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Backdrop from "@mui/material/Backdrop";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";

import Drawer from "@mui/material/Drawer";
import ClickAwayListener from "@mui/material/ClickAwayListener";

import styles from "./styles";
const defaultState = {
  isDrawerOpen: false,
};

export default function SidebarHeader({ drawerList = [], children = <></> }) {
  const [state, setState] = useState(defaultState);
  const navigate = useNavigate();
  const location = useLocation();
  const isActiveItem = (itemRoute) => {
    let isActive = false;
    const currentPath = location.pathname;
    if (currentPath === itemRoute || currentPath === `${itemRoute}/`) {
      isActive = true;
    }
    return isActive;
  };

  const logo = state.isDrawerOpen ? "brand-logo-white.svg" : "R-Icon.svg";
  return (
    <>
      <ClickAwayListener
        onClickAway={() =>
          setState((prevState) => ({
            ...prevState,
            isDrawerOpen: false,
          }))
        }
      >
        <Drawer
          PaperProps={{
            sx: state.isDrawerOpen ? styles.drawerOpen : styles.drawerClose,
          }}
          variant="permanent"
          elevation={0}
          onClick={() =>
            setState((prevState) => ({
              ...prevState,
              isDrawerOpen: !prevState.isDrawerOpen,
            }))
          }
        >
          <Box sx={styles.container}>
            <IconButton>
              <img
                src={`/assets/${logo}`}
                alt="Brand Logo"
                style={state.isDrawerOpen ? styles.rcLogo : styles.logo}
              />
            </IconButton>
            <Box sx={styles.drawerList}>
              {drawerList.map((item) => {
                return state.isDrawerOpen ? (
                  <Box sx={styles.btnContainer}>
                    <Button
                      startIcon={
                        isActiveItem(item.to) ? item.activeIcon : item.icon
                      }
                      sx={{
                        ...(isActiveItem(item.to)
                          ? styles.drawerButtonActive
                          : styles.drawerButtonInActive),
                      }}
                      onClick={() => navigate(`${item.to}`)}
                    >
                      {item.label}
                    </Button>
                  </Box>
                ) : (
                  <Tooltip title={item.tooltipLabel} placement="top">
                    <Button
                      onClick={(e) => {
                        navigate(`${item.to}`);
                        e.preventDefault();
                        e.stopPropagation();
                      }}
                      sx={{
                        ...(isActiveItem(item.to)
                          ? styles.drawerButtonClose
                          : styles.drawerButton),
                      }}
                    >
                      {isActiveItem(item.to) ? item.activeIcon : item.icon}
                    </Button>
                  </Tooltip>
                );
              })}
            </Box>
          </Box>

          <Box sx={styles.iconContainer}>
            <img
              src="/assets/psi-white-logo.svg"
              alt="Psi Logo"
              width="34px"
              height="34px"
            />
          </Box>
        </Drawer>
      </ClickAwayListener>
      <Box sx={styles.content}>
        <Header />
        {children}
      </Box>
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={state.isDrawerOpen}
        onClick={() =>
          setState((prevState) => ({
            ...prevState,
            isDrawerOpen: false,
          }))
        }
      />
    </>
  );
}
